<template>
  <div class="container">
    <div class="img-box">
      <img class="long-img" src="@assets/promotion-h5/long-img.jpg" alt="" />
        <!-- 合作品牌 -->
       <div class="swiper">
         <div class="swiper-container">
           <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="@assets/promotion/brand-1.png" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="@assets/promotion/brand-2.png" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="@assets/promotion/brand-3.png" alt="" />
            </div>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
         </div>
       </div>

        <!-- 合作案例 -->
        <div class="swiper-example">
          <div class="example-list">
            <div
              class="example-item"
              :class="{'active': index === exampleIndex}"
              v-for="(item, index) in exampleData"
              :key="index"
              @click="handleSelectExample(index)">
              {{item.label}}
            </div>
          </div>
         <div class="swiper-example-container">
           <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in exampleData"
              :key="index">
              <div class="example-panel">
                <div class="example-panel-left">
                  <img :src="item.img" alt="" />
                </div>
                <div class="example-panel-right">
                  <div class="panel-right-title">{{item.title}}</div>
                  <div v-html="index === 4 ? item.h5Text : item.text"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="swiper-pagination swiper-example-pagination" slot="pagination"></div> -->
         </div>
       </div>
    </div>

    <div class="booking-box">
      <div class="booking-text">如您感兴趣，可扫码添加官方企微咨询。</div>
      <div class="booking-text">（{{month}}月份招募，仅限500名额）</div>
      <img class="qr-code" src="@assets/promotion-h5/qr-code.png" alt="" />
      <img class="phone-btn" src="@assets/promotion-h5/phone-btn.gif" alt="" @click="handleCallPhone" />
    </div>

    <div class="contact-box">
      <div>报名方式1：</div>
      <div class="contact-wrap">
        <div class="contact-left">
          <div class="contact-item">
            <div>公司名</div>
            <input class="input-text" v-model="applyName" placeholder="请输入您的公司名" type="text">
          </div>
          <div class="contact-item">
            <div>手机号</div>
            <input class="input-text" v-model="applyPhone" placeholder="请输入您的手机号" type="number">
          </div>
        </div>
        <img class="contact-btn" src="@assets/promotion-h5/booking-btn.gif" alt="" @click="handleBook" />
      </div>
      <div>报名方式2：</div>
      <div class="email-wrap">
        发送申请邮件至官方邮箱：elieen.lee@vipshop.com
        <div class="copy-btn" data-clipboard-text="elieen.lee@vipshop.com" @click="copy">复制</div>
      </div>
    </div>

    <div class="dialog-wrap" v-if="isShowDialog">
      <div class="mask"></div>
      <div class="dialog">
        <div class="dialog-content">预约咨询成功，我们将尽快联系您</div>
        <div class="dialog-footer">
          <div class="dialog-btn" @click="closeDialog">关闭</div>
          <div class="dialog-btn active" @click="closeDialog">知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import util from '@/utils'
import api from '@/lib/api'
import {encrypt} from '@/lib/encryptor'
import {EXAMPLE_DATA} from '@/config/constants'

export default {
  name: 'promotion-h5',
  data() {
    return {
      isShowDialog: false,
      applyName: '',
      applyPhone: '',
      month: '',
      exampleData: EXAMPLE_DATA,
      exampleSwiper: null,
      exampleIndex: 0,
    }
  },
  created() {
    util.setHtmlFontSize()
    this.month = new Date().getMonth() + 1
  },
  mounted() {
    setTimeout(() => {
      let mySwiper = new Swiper('.swiper-container', {
        direction: 'horizontal', //滑动方向，可设置水平(horizontal)或垂直(vertical)。
        loop: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        paginationClickable: true,
        observer: true,
        observeParents: true
      })
      var that = this
      this.exampleSwiper = new Swiper('.swiper-example-container', {
        direction: 'horizontal', //滑动方向，可设置水平(horizontal)或垂直(vertical)。
        loop: false,
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
        },
        on: {
          slideChange: function() {
            that.exampleIndex = this.activeIndex
          }
        },
        // 如果需要分页器
        pagination: {
          el: '.swiper-example-pagination',
          clickable: true,
        },
        paginationClickable: true,
        observer: true,
        observeParents: true
      })
    }, 500)

    this.$tracker.page('wdg_page_official_website', {
      page_id: 1 // business cooperation 商务合作
    })
  },
  methods: {
    handleSelectExample(index) {
      this.exampleSwiper.slideTo(index)
    },
    handleBook() {
      if (!this.applyName) {
        util.toast('请填入您的公司名')
        return
      }
      if (!this.applyPhone) {
        util.toast('请填入您的手机号')
        return
      }
      if (!util.validate('mobile', this.applyPhone)) {
				util.toast('手机号格式不正确')
				return
			}
      let data = {
        applyName: encrypt(this.applyName),
        applyPhone: encrypt(this.applyPhone),
      }
      api.applyChannel(data).then(() => {
        this.isShowDialog = true
      }).catch(err => {
        util.toast(err.msg || err.message)
      })
    },
    closeDialog() {
      this.isShowDialog = false
    },
    handleCallPhone() {
      window.location.href = 'tel:020-22330962';
    },
    copy() {
      var clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', () => {
				util.toast('复制成功')
				clipboard.destroy()
			})
			clipboard.on('error', () => {
				util.toast('手机不支持复制功能')
				clipboard.destroy()
			})
    }
  }
}
</script>

<style lang="stylus" scoped>
.container {
  width: 7.5rem;
  margin: 0 auto;
  background: #E1017E;
  box-sizing: border-box;
  overflow: hidden;
  padding-bottom: 3.7rem;
  .img-box {
    position: relative;
    .long-img {
      width: 7.5rem;
      height: 42.9rem;
    }
    .swiper {
      position: absolute;
      bottom: 15.5rem;
      left: 50%;
      transform: translateX(-50%);
      width: 6.5rem;
      height: 3rem;
      z-index: 9;
      .swiper-container {
        width: 100%;
        height: 100%;
      }
      img {
        width: 100%;
        height: 2.5rem;
      }
    }
    /deep/ .swiper-pagination-bullet {
      width: .12rem;
      height: .12rem;
    }
    /deep/ .swiper-pagination-bullet-active {
      background: #e1017e;
    }

    .swiper-example {
      position: absolute;
      bottom: .9rem;
      left: 50%;
      transform: translateX(-50%);
      width: 7rem;
      z-index: 9;
      .example-list {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap
        .example-item {
          width: 1.7rem;
          height: .55rem;
          line-height: .55rem;
          text-align: center;
          background: #fff;
          border-radius: .08rem;
          border: 1px solid #333;
          box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2000);
          margin-top: .2rem;
          margin-right: .4rem;
          font-size: .28rem;
          color: #666;
          &.active {
            background: #F90080;
            border-color: #F90080;
            color: #fff;
          }
        }
        .example-item:nth-child(3n) {
          margin-right: 0;
        }
      }

      .swiper-example-container {
        margin-top: .2rem;
        width: 100%;
        height: 4.2rem;
        overflow: hidden;
        background: #F5F5F5;
        border-radius: .2rem;

        .example-panel {
          width: 100%;
          height: 100%;
          display: flex;
          // background: #F5F5F5;
          // border-radius: .3rem;
          overflow: hidden;
          .example-panel-left {
            width: 2.2rem;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            margin-left: .25rem;
            img {
              width: 100%;
              height: 3.73rem;
            }
          }
          .example-panel-right {
            width: 4rem;
            height: 100%;
            margin-left: .3rem;
            box-sizing: border-box;
            color: #666;
            font-size: .2rem;
            line-height: .28rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .panel-right-title {
              font-size: .22rem;
              font-weight: bold;
              margin-bottom: .2rem;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .booking-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: .4rem;
    position:relative;
    .booking-text {
      font-size: .28rem;
      color: #fff;
      text-align: center;
      line-height: .4rem;
    }
    .qr-code {
      width: 3rem;
      height: 3rem;
      margin-top: .2rem;
      border-radius: .15rem;
      background: #fff;
    }
    .phone-btn {
      position: absolute;
      right: .1rem;
      top: 1.2rem;
      width: 1.3rem;
      height: 1.3rem;
    }
  }

  .contact-box {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 7.5rem;
    z-index: 99;
    transform: translateX(-50%);
    padding: .2rem .3rem .35rem;
    padding-bottom: calc(.35rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(.35rem + env(safe-area-inset-bottom));
    box-sizing: border-box;
    background: #fff;
    border-radius: .15rem .15rem 0 0;
    color: #333;
    font-size: .24rem;

    .contact-wrap {
      display: flex;
      justify-content: space-between;
      align-items: space-between;
      margin: .1rem 0;

      .contact-left {
        flex: 1 1 auto;
        margin-right: .2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .contact-item {
          display: flex;
          align-items: center;
          font-size: .28rem;
          color: #F90080;
          font-weight: bold;
          .input-text {
            flex: 1 1 auto;
            height: .6rem;
            line-height: .6rem;
            margin-left: .2rem;
            border: 1px solid #979797;
            border-radius: .1rem
            color: #333;
            font-size: .26rem;
            outline-style: none;
            padding: 0 .2rem;
            box-sizing: border-box;
            &::placeholder {
              color: #A3A3A3
            }
          }
        }
      }

      .contact-btn {
        width: 1.4rem;
        height: 1.4rem;
      }
    }

    .email-wrap {
      margin-top: .1rem;
      color: #333;
      font-size: .28rem;
      line-height: .4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .copy-btn {
        width: .8rem;
        height: .4rem;
        text-align: center;
        line-height: .4rem;
        border-radius: .08rem;
        border: 1px solid #F90080;
        color: #F90080;
        font-size: .24rem;
      }
    }
  }

  .dialog-wrap {
    .mask {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%)
      width: 7.5rem;
      height: 100%;
      z-index 96;
      background: rgba(0, 0, 0, 0.5);
    }
    .dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      width: 5.6rem;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: .2rem;
      overflow: hidden;
      z-index:99;
      padding: .6rem .55rem .5rem;
      text-align: center;
      color: #010101;
      font-size: .3rem;

      .dialog-footer {
        margin-top: .45rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .dialog-btn {
          width: 2rem;
          height: .7rem;
          line-height: .7rem;
          text-align: center;
          border: 1px solid #F90080;
          border-radius: .45rem;
          font-size: .32rem;
          color: #F90080;
          background: #fff;
          text-decoration: none;
        }
        .active {
          color #fff;
          background: #F90080;
          margin-left: .3rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/promotion-h5.vue